
import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EntryConfigUnion } from "@/types/entryConfig";
import { useUnsavedChangesGuard } from "@/hooks/useUnsavedChangesGuard";
import AddTraitForm from "./AddTraitForm";

interface AddTraitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTraitAdded: (config: Omit<EntryConfigUnion, "id" | "createdAt" | "createdBy" | "updatedAt" | "updatedBy">) => void;
  existingNames?: string[];
}

const AddTraitDialog: React.FC<AddTraitDialogProps> = ({
  open,
  onOpenChange,
  onTraitAdded,
  existingNames,
}) => {
  const [isDirty, setIsDirty] = useState(false);
  // Warn before discarding an in-progress trait (Escape, click-outside, X, Cancel).
  const guard = useUnsavedChangesGuard({ isDirty, onOpenChange });

  const handleTraitAdded = (config: Omit<EntryConfigUnion, "id" | "createdAt" | "createdBy" | "updatedAt" | "updatedBy">) => {
    onTraitAdded(config);
    onOpenChange(false);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={guard.guardedOnOpenChange}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle>Add New Trait</DialogTitle>
          </DialogHeader>
          <div className="overflow-y-auto flex-1 pr-4 -mr-2">
            <AddTraitForm
              onSubmit={handleTraitAdded}
              onCancel={guard.requestClose}
              existingNames={existingNames}
              onDirtyChange={setIsDirty}
            />
          </div>
        </DialogContent>
      </Dialog>

      {guard.confirmation}
    </>
  );
};

export default AddTraitDialog;
